import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';

import { User } from '../models/user.model';
import { ApiService } from '../http/api.service';

@Injectable({providedIn: 'root'})
export class AuthService {
  private authState = false;

  constructor(
    private apiService: ApiService,
    private router: Router,
  ) {}

  async checkUserLogin(data: User) {
    try {
      localStorage.clear();

      const userResponse: any = await this.apiService.login(data);

      if (userResponse && userResponse.token) {
        localStorage.setItem('userToken', JSON.stringify(userResponse));
        this.router.navigate(['/company']);
      } else {
        throw new Error('Resposta inválida do servidor - token não encontrado');
      }
    } catch (error) {
      console.error('Erro no login:', error);
      localStorage.clear();
      
      // Se for erro da API (401), mostra a mensagem original
      if (error.message && (error.message.includes('Usuário não encontrado') || error.message.includes('Credenciais inválidas'))) {
        throw error; // Mantém a mensagem original da API
      } else {
        throw new Error('Erro ao conectar com o servidor. Verifique sua conexão.');
      }
    }
  }

  refreshToken() {
    const token = this.getUserToken();
    
    if (!token || !token.refresh_token) {
      this.logout();
      return throwError('Token de refresh não encontrado');
    }

    return this.apiService.refreshToken(
      { refresh_token: token.refresh_token }
    );
  }

  logout() {
    this.router.navigate(['/auth']);
    localStorage.clear();
    this.setUserState(false);
  }

  getUserToken() {
    try {
      const userToken = localStorage.getItem('userToken');
      if (!userToken) {
        return null;
      }
      const parsed = JSON.parse(userToken);
      return parsed && parsed.token ? parsed : null;
    } catch (error) {
      console.error('Error parsing userToken from localStorage:', error);
      localStorage.removeItem('userToken');
      return null;
    }
  }

  isAuthenticated() {
    const token = this.getUserToken();

    if (token && token.token) {
      return this.setUserState(true);
    }

    return this.setUserState(false);
  }

  getUserState() {
    this.isAuthenticated();
    return this.authState;
  }

  setUserState(value: boolean) {
    this.authState = value;
  }

}
